import { render, staticRenderFns } from "./TransmitForm-V2.vue?vue&type=template&id=beafb1c6"
import script from "./TransmitForm-V2.vue?vue&type=script&lang=js"
export * from "./TransmitForm-V2.vue?vue&type=script&lang=js"
import style0 from "./TransmitForm-V2.vue?vue&type=style&index=0&id=beafb1c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports